export default {
  createEvent: 'Create event',
  editEvent: 'Edit: {0}',
};
